import { render, staticRenderFns } from "./Detail-Supplier.vue?vue&type=template&id=1fc24aec"
import script from "./Detail-Supplier.vue?vue&type=script&lang=js"
export * from "./Detail-Supplier.vue?vue&type=script&lang=js"
import style0 from "./Detail-Supplier.vue?vue&type=style&index=0&id=1fc24aec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports